<div>
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="onBackClick()"
      >
      </dx-button>
      <dx-button
        [text]="'LEARNING-PATHS.LEARNING-PATH-INVITE.SEND-INVITATIONS' | translate"
        stylingMode="contained"
        type="normal"
        (click)="onSendClick()"
      >
      </dx-button>
    </div>
    <app-panel [title]="'LEARNING-PATHS.LEARNING-PATH-INVITE.RECIPIENTS' | translate">
      <dx-form [formData]="formData" labelLocation="top" #recipientsForm>
        <dxi-item dataField="to">
          <dxo-label
            [text]="'LEARNING-PATHS.LEARNING-PATH-INVITE.TO' | translate"
          ></dxo-label>
          <div *dxTemplate>
            <app-invite-person-select-dialog
              [(selectedPersons)]="formData.to"
            >
              <dx-tag-box
                [showSelectionControls]="true"
                applyValueMode="useButtons"
                tagTemplate="customTag"
                class="no-events"
                [(value)]="formData.to"
                [items]="formData.to"
              >
                <div *dxTemplate="let product of 'customItem'">
                  <div class="custom-item">
                    <div class="product-name">
                      {{ product.lastName }},
                      {{ product.firstName }}
                    </div>
                  </div>
                </div>
                <div *dxTemplate="let product of 'customTag'">
                  <div class="dx-tag-content">
                    <div>
                      {{ product.lastName }},
                      {{ product.firstName }}
                    </div>
                    <div class="dx-tag-remove-button"></div>
                  </div>
                </div>
              </dx-tag-box>
            </app-invite-person-select-dialog>
          </div>
        </dxi-item>
        <dxi-item>
          <dxo-label
            [text]="'COMMON.UPLOAD-ATTACHMENTS' | translate"
          ></dxo-label>
          <div *dxTemplate>
            <dx-file-uploader
              [visible]="false"
              dialogTrigger="#fileTrigger"
              [multiple]="true"
              uploadMode="useForm"
              (valueChange)="onSelectedFileChange($event)"
              [showFileList]="true"
            >
            </dx-file-uploader>
            <dx-button
              id="fileTrigger"
              [text]="'COMMON.SELECT-FILE' | translate"
              type="default"
              class="integration-btn"
            ></dx-button>
            <span *ngIf="!formData.files.length" class="no-file-text">
              {{ 'COMMON.FILE-NOT-SELECTED' | translate }}
            </span>
            <div *ngIf="formData.files.length">
              <dx-list
                [width]="'50%'"
                noDataText=""
                [dataSource]="formData.files"
                keyExpr="name"
                displayExpr="name"
              ></dx-list>
            </div>
          </div>
        </dxi-item>
      </dx-form>
    </app-panel>
    <app-panel [title]="'LEARNING-PATHS.LEARNING-PATH-INVITE.CONTENT' | translate">
      <dx-form [formData]="formData" labelMode="floating" #contentForm>
        <dxi-item
          dataField="subject"
          [label]="'LEARNING-PATHS.LEARNING-PATH-INVITE.SUBJECT' | translate"
        >
          <dxi-validation-rule
            type="required"
            [message]="
              'LEARNING-PATHS.LEARNING-PATH-INVITE.SUBJECT-REQUIRED' | translate
            "
          ></dxi-validation-rule>
        </dxi-item>

        <dxi-item>
          <dxo-label
            [text]="'LEARNING-PATHS.LEARNING-PATH-INVITE.TEXT' | translate"
          ></dxo-label>
          <div *dxTemplate>
            <div class="invitation-text-wrapper">
              <app-expandable-text-editor
                [(value)]="formData.body"
                [placeholder]="'LEARNING-PATHS.LEARNING-PATH-INVITE.TEXT' | translate"
              ></app-expandable-text-editor>
            </div>
          </div>
        </dxi-item>
      </dx-form>
      <div 
        *ngIf="userContext.canUseTextTemplates"
        class="text-template-container"
      >
        <app-text-template-selector
          [type]="invitationTextTemplateType"
          [content]="formData.body"
          (contentChange)="onTemplateContentChanged($event)"
        ></app-text-template-selector>
      </div>
    </app-panel>
  </app-page>
</div>
